<template>
    <div>
        <v-text-field
                v-model="color"
                outlined
                dense
                :readonly="readonly"
                :color="inputColor"
                :background-color="backgroundColor"
                @click="menu = true"
                :clearable="!readonly"
                @click:clear="clear"
        >
            <template v-slot:append>
                <v-menu
                        v-model="menu"
                        bottom
                        nudge-bottom="30"
                        nudge-left="16"
                        :close-on-content-click="true"
                >
                    <template v-slot:activator="{ on }">
                        <v-card flat :color="color" width="60" height="25" v-on="on"></v-card>
                    </template>
                    <v-card width="350" height="400" style="overflow-y: auto">
                        <v-card-text>
                            <v-container fluid>
                                <v-row>
                                    <v-col cols="3" v-for="(item, index) in colors" :key="`item-${index}`">
                                        <v-row dense>
                                            <v-col cols="12" v-for="(item2, indey) in item" :key="`ìtem2-${indey}`">
                                                <v-card
                                                    :color="item2.name"
                                                    width="60"
                                                    height="25"
                                                    @click="save(item2)"
                                                ></v-card>
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-card>
                </v-menu>
            </template>
        </v-text-field>
        <input type="hidden"/>
    </div>
</template>

<script>
import useSharedData from "@/use/SharedData";
import {ref, watch} from "vue";

export default {
    name: "WVuetifyColorPicker",
    props: {
        value: String,
        readonly: Boolean,
    },
    setup(props, {emit}) {
        const {backgroundColor, inputColor} = useSharedData();
        const colors = [
            [
                {hex: '#F44336', name: 'red'},
                {hex: '#FFEBEE', name: 'red lighten-5'},
                {hex: '#FFCDD2', name: 'red lighten-4'},
                {hex: '#EF9A9A', name: 'red lighten-3'},
                {hex: '#E57373', name: 'red lighten-2'},
                {hex: '#EF5350', name: 'red lighten-1'},
                {hex: '#E53935', name: 'red darken-1'},
                {hex: '#D32F2F', name: 'red darken-2'},
                {hex: '#C62828', name: 'red darken-3'},
                {hex: '#B71C1C', name: 'red darken-4'},
                {hex: '#FF8A80', name: 'red accent-1'},
                {hex: '#FF5252', name: 'red accent-2'},
                {hex: '#FF1744', name: 'red accent-3'},
                {hex: '#D50000', name: 'red accent-4'},
            ],
            [
                {hex: '#E91E63', name: 'pink'},
                {hex: '#FCE4EC', name: 'pink lighten-5'},
                {hex: '#F8BBD0', name: 'pink lighten-4'},
                {hex: '#F48FB1', name: 'pink lighten-3'},
                {hex: '#F06292', name: 'pink lighten-2'},
                {hex: '#EC407A', name: 'pink lighten-1'},
                {hex: '#D81B60', name: 'pink darken-1'},
                {hex: '#C2185B', name: 'pink darken-2'},
                {hex: '#AD1457', name: 'pink darken-3'},
                {hex: '#880E4F', name: 'pink darken-4'},
                {hex: '#FF80AB', name: 'pink accent-1'},
                {hex: '#FF4081', name: 'pink accent-2'},
                {hex: '#F50057', name: 'pink accent-3'},
                {hex: '#C51162', name: 'pink accent-4'},
            ],
            [
                {hex: '#9C27B0', name: 'purple'},
                {hex: '#F3E5F5', name: 'purple lighten-5'},
                {hex: '#E1BEE7', name: 'purple lighten-4'},
                {hex: '#CE93D8', name: 'purple lighten-3'},
                {hex: '#BA68C8', name: 'purple lighten-2'},
                {hex: '#AB47BC', name: 'purple lighten-1'},
                {hex: '#8E24AA', name: 'purple darken-1'},
                {hex: '#7B1FA2', name: 'purple darken-2'},
                {hex: '#6A1B9A', name: 'purple darken-3'},
                {hex: '#4A148C', name: 'purple darken-4'},
                {hex: '#EA80FC', name: 'purple accent-1'},
                {hex: '#E040FB', name: 'purple accent-2'},
                {hex: '#D500F9', name: 'purple accent-3'},
                {hex: '#AA00FF', name: 'purple accent-4'},
            ],
            [
                {hex: '#673AB7', name: 'deep-purple'},
                {hex: '#EDE7F6', name: 'deep-purple lighten-5'},
                {hex: '#D1C4E9', name: 'deep-purple lighten-4'},
                {hex: '#B39DDB', name: 'deep-purple lighten-3'},
                {hex: '#9575CD', name: 'deep-purple lighten-2'},
                {hex: '#7E57C2', name: 'deep-purple lighten-1'},
                {hex: '#5E35B1', name: 'deep-purple darken-1'},
                {hex: '#512DA8', name: 'deep-purple darken-2'},
                {hex: '#4527A0', name: 'deep-purple darken-3'},
                {hex: '#311B92', name: 'deep-purple darken-4'},
                {hex: '#B388FF', name: 'deep-purple accent-1'},
                {hex: '#7C4DFF', name: 'deep-purple accent-2'},
                {hex: '#651FFF', name: 'deep-purple accent-3'},
                {hex: '#6200EA', name: 'deep-purple accent-4'},
            ],
            [
                {hex: '#3F51B5', name: 'indigo'},
                {hex: '#E8EAF6', name: 'indigo lighten-5'},
                {hex: '#C5CAE9', name: 'indigo lighten-4'},
                {hex: '#9FA8DA', name: 'indigo lighten-3'},
                {hex: '#7986CB', name: 'indigo lighten-2'},
                {hex: '#5C6BC0', name: 'indigo lighten-1'},
                {hex: '#3949AB', name: 'indigo darken-1'},
                {hex: '#303F9F', name: 'indigo darken-2'},
                {hex: '#283593', name: 'indigo darken-3'},
                {hex: '#1A237E', name: 'indigo darken-4'},
                {hex: '#8C9EFF', name: 'indigo accent-1'},
                {hex: '#536DFE', name: 'indigo accent-2'},
                {hex: '#3D5AFE', name: 'indigo accent-3'},
                {hex: '#304FFE', name: 'indigo accent-4'},
            ],
            [
                {hex: '#2196F3', name: 'blue'},
                {hex: '#E3F2FD', name: 'blue lighten-5'},
                {hex: '#BBDEFB', name: 'blue lighten-4'},
                {hex: '#90CAF9', name: 'blue lighten-3'},
                {hex: '#64B5F6', name: 'blue lighten-2'},
                {hex: '#42A5F5', name: 'blue lighten-1'},
                {hex: '#1E88E5', name: 'blue darken-1'},
                {hex: '#1976D2', name: 'blue darken-2'},
                {hex: '#1565C0', name: 'blue darken-3'},
                {hex: '#0D47A1', name: 'blue darken-4'},
                {hex: '#82B1FF', name: 'blue accent-1'},
                {hex: '#448AFF', name: 'blue accent-2'},
                {hex: '#2979FF', name: 'blue accent-3'},
                {hex: '#2962FF', name: 'blue accent-4'},
            ],
            [
                {hex: '#03A9F4', name: 'light-blue'},
                {hex: '#E1F5FE', name: 'light-blue lighten-5'},
                {hex: '#B3E5FC', name: 'light-blue lighten-4'},
                {hex: '#81D4FA', name: 'light-blue lighten-3'},
                {hex: '#4FC3F7', name: 'light-blue lighten-2'},
                {hex: '#29B6F6', name: 'light-blue lighten-1'},
                {hex: '#039BE5', name: 'light-blue darken-1'},
                {hex: '#0288D1', name: 'light-blue darken-2'},
                {hex: '#0277BD', name: 'light-blue darken-3'},
                {hex: '#01579B', name: 'light-blue darken-4'},
                {hex: '#80D8FF', name: 'light-blue accent-1'},
                {hex: '#40C4FF', name: 'light-blue accent-2'},
                {hex: '#00B0FF', name: 'light-blue accent-3'},
                {hex: '#0091EA', name: 'light-blue accent-4'},
            ],
            [
                {hex: '#00BCD4', name: 'cyan'},
                {hex: '#E0F7FA', name: 'cyan lighten-5'},
                {hex: '#B2EBF2', name: 'cyan lighten-4'},
                {hex: '#80DEEA', name: 'cyan lighten-3'},
                {hex: '#4DD0E1', name: 'cyan lighten-2'},
                {hex: '#26C6DA', name: 'cyan lighten-1'},
                {hex: '#00ACC1', name: 'cyan darken-1'},
                {hex: '#0097A7', name: 'cyan darken-2'},
                {hex: '#00838F', name: 'cyan darken-3'},
                {hex: '#006064', name: 'cyan darken-4'},
                {hex: '#84FFFF', name: 'cyan accent-1'},
                {hex: '#18FFFF', name: 'cyan accent-2'},
                {hex: '#00E5FF', name: 'cyan accent-3'},
                {hex: '#00B8D4', name: 'cyan accent-4'},
            ],
            [
                {hex: '#009688', name: 'teal'},
                {hex: '#E0F2F1', name: 'teal lighten-5'},
                {hex: '#B2DFDB', name: 'teal lighten-4'},
                {hex: '#80CBC4', name: 'teal lighten-3'},
                {hex: '#4DB6AC', name: 'teal lighten-2'},
                {hex: '#26A69A', name: 'teal lighten-1'},
                {hex: '#00897B', name: 'teal darken-1'},
                {hex: '#00796B', name: 'teal darken-2'},
                {hex: '#00695C', name: 'teal darken-3'},
                {hex: '#004D40', name: 'teal darken-4'},
                {hex: '#A7FFEB', name: 'teal accent-1'},
                {hex: '#64FFDA', name: 'teal accent-2'},
                {hex: '#1DE9B6', name: 'teal accent-3'},
                {hex: '#00BFA5', name: 'teal accent-4'},
            ],
            [
                {hex: '#4CAF50', name: 'green'},
                {hex: '#E8F5E9', name: 'green lighten-5'},
                {hex: '#C8E6C9', name: 'green lighten-4'},
                {hex: '#A5D6A7', name: 'green lighten-3'},
                {hex: '#81C784', name: 'green lighten-2'},
                {hex: '#66BB6A', name: 'green lighten-1'},
                {hex: '#43A047', name: 'green darken-1'},
                {hex: '#388E3C', name: 'green darken-2'},
                {hex: '#2E7D32', name: 'green darken-3'},
                {hex: '#1B5E20', name: 'green darken-4'},
                {hex: '#B9F6CA', name: 'green accent-1'},
                {hex: '#69F0AE', name: 'green accent-2'},
                {hex: '#00E676', name: 'green accent-3'},
                {hex: '#00C853', name: 'green accent-4'},
            ],
            [
                {hex: '#8BC34A', name: 'light-green'},
                {hex: '#F1F8E9', name: 'light-green lighten-5'},
                {hex: '#DCEDC8', name: 'light-green lighten-4'},
                {hex: '#C5E1A5', name: 'light-green lighten-3'},
                {hex: '#AED581', name: 'light-green lighten-2'},
                {hex: '#9CCC65', name: 'light-green lighten-1'},
                {hex: '#7CB342', name: 'light-green darken-1'},
                {hex: '#689F38', name: 'light-green darken-2'},
                {hex: '#558B2F', name: 'light-green darken-3'},
                {hex: '#33691E', name: 'light-green darken-4'},
                {hex: '#CCFF90', name: 'light-green accent-1'},
                {hex: '#B2FF59', name: 'light-green accent-2'},
                {hex: '#76FF03', name: 'light-green accent-3'},
                {hex: '#64DD17', name: 'light-green accent-4'},
            ],
            [
                {hex: '#CDDC39', name: 'lime'},
                {hex: '#F9FBE7', name: 'lime lighten-5'},
                {hex: '#F0F4C3', name: 'lime lighten-4'},
                {hex: '#E6EE9C', name: 'lime lighten-3'},
                {hex: '#DCE775', name: 'lime lighten-2'},
                {hex: '#D4E157', name: 'lime lighten-1'},
                {hex: '#C0CA33', name: 'lime darken-1'},
                {hex: '#AFB42B', name: 'lime darken-2'},
                {hex: '#9E9D24', name: 'lime darken-3'},
                {hex: '#827717', name: 'lime darken-4'},
                {hex: '#F4FF81', name: 'lime accent-1'},
                {hex: '#EEFF41', name: 'lime accent-2'},
                {hex: '#C6FF00', name: 'lime accent-3'},
                {hex: '#AEEA00', name: 'lime accent-4'},
            ],
            [
                {hex: '#FFEB3B', name: 'yellow'},
                {hex: '#FFFDE7', name: 'yellow lighten-5'},
                {hex: '#FFF9C4', name: 'yellow lighten-4'},
                {hex: '#FFF59D', name: 'yellow lighten-3'},
                {hex: '#FFF176', name: 'yellow lighten-2'},
                {hex: '#FFEE58', name: 'yellow lighten-1'},
                {hex: '#FDD835', name: 'yellow darken-1'},
                {hex: '#FBC02D', name: 'yellow darken-2'},
                {hex: '#F9A825', name: 'yellow darken-3'},
                {hex: '#F57F17', name: 'yellow darken-4'},
                {hex: '#FFFF8D', name: 'yellow accent-1'},
                {hex: '#FFFF00', name: 'yellow accent-2'},
                {hex: '#FFEA00', name: 'yellow accent-3'},
                {hex: '#FFD600', name: 'yellow accent-4'},
            ],
            [
                {hex: '#FFC107', name: 'amber'},
                {hex: '#FFF8E1', name: 'amber lighten-5'},
                {hex: '#FFECB3', name: 'amber lighten-4'},
                {hex: '#FFE082', name: 'amber lighten-3'},
                {hex: '#FFD54F', name: 'amber lighten-2'},
                {hex: '#FFCA28', name: 'amber lighten-1'},
                {hex: '#FFB300', name: 'amber darken-1'},
                {hex: '#FFA000', name: 'amber darken-2'},
                {hex: '#FF8F00', name: 'amber darken-3'},
                {hex: '#FF6F00', name: 'amber darken-4'},
                {hex: '#FFE57F', name: 'amber accent-1'},
                {hex: '#FFD740', name: 'amber accent-2'},
                {hex: '#FFC400', name: 'amber accent-3'},
                {hex: '#FFAB00', name: 'amber accent-4'},
            ],
            [
                {hex: '#FF9800', name: 'orange'},
                {hex: '#FFF3E0', name: 'orange lighten-5'},
                {hex: '#FFE0B2', name: 'orange lighten-4'},
                {hex: '#FFCC80', name: 'orange lighten-3'},
                {hex: '#FFB74D', name: 'orange lighten-2'},
                {hex: '#FFA726', name: 'orange lighten-1'},
                {hex: '#FB8C00', name: 'orange darken-1'},
                {hex: '#F57C00', name: 'orange darken-2'},
                {hex: '#EF6C00', name: 'orange darken-3'},
                {hex: '#E65100', name: 'orange darken-4'},
                {hex: '#FFD180', name: 'orange accent-1'},
                {hex: '#FFAB40', name: 'orange accent-2'},
                {hex: '#FF9100', name: 'orange accent-3'},
                {hex: '#FF6D00', name: 'orange accent-4'},
            ],
            [
                {hex: '#FF5722', name: 'deep-orange'},
                {hex: '#FBE9E7', name: 'deep-orange lighten-5'},
                {hex: '#FFCCBC', name: 'deep-orange lighten-4'},
                {hex: '#FFAB91', name: 'deep-orange lighten-3'},
                {hex: '#FF8A65', name: 'deep-orange lighten-2'},
                {hex: '#FF7043', name: 'deep-orange lighten-1'},
                {hex: '#F4511E', name: 'deep-orange darken-1'},
                {hex: '#E64A19', name: 'deep-orange darken-2'},
                {hex: '#D84315', name: 'deep-orange darken-3'},
                {hex: '#BF360C', name: 'deep-orange darken-4'},
                {hex: '#FF9E80', name: 'deep-orange accent-1'},
                {hex: '#FF6E40', name: 'deep-orange accent-2'},
                {hex: '#FF3D00', name: 'deep-orange accent-3'},
                {hex: '#DD2C00', name: 'deep-orange accent-4'},
            ],
            [
                {hex: '#795548', name: 'brown'},
                {hex: '#EFEBE9', name: 'brown lighten-5'},
                {hex: '#D7CCC8', name: 'brown lighten-4'},
                {hex: '#BCAAA4', name: 'brown lighten-3'},
                {hex: '#A1887F', name: 'brown lighten-2'},
                {hex: '#8D6E63', name: 'brown lighten-1'},
                {hex: '#6D4C41', name: 'brown darken-1'},
                {hex: '#5D4037', name: 'brown darken-2'},
                {hex: '#4E342E', name: 'brown darken-3'},
                {hex: '#3E2723', name: 'brown darken-4'},
            ],
            [
                {hex: '#607D8B', name: 'blue-grey'},
                {hex: '#ECEFF1', name: 'blue-grey lighten-5'},
                {hex: '#CFD8DC', name: 'blue-grey lighten-4'},
                {hex: '#B0BEC5', name: 'blue-grey lighten-3'},
                {hex: '#90A4AE', name: 'blue-grey lighten-2'},
                {hex: '#78909C', name: 'blue-grey lighten-1'},
                {hex: '#546E7A', name: 'blue-grey darken-1'},
                {hex: '#455A64', name: 'blue-grey darken-2'},
                {hex: '#37474F', name: 'blue-grey darken-3'},
                {hex: '#263238', name: 'blue-grey darken-4'},
            ],
            [
                {hex: '#9E9E9E', name: 'grey'},
                {hex: '#FAFAFA', name: 'grey lighten-5'},
                {hex: '#F5F5F5', name: 'grey lighten-4'},
                {hex: '#EEEEEE', name: 'grey lighten-3'},
                {hex: '#E0E0E0', name: 'grey lighten-2'},
                {hex: '#BDBDBD', name: 'grey lighten-1'},
                {hex: '#757575', name: 'grey darken-1'},
                {hex: '#616161', name: 'grey darken-2'},
                {hex: '#424242', name: 'grey darken-3'},
                {hex: '#212121', name: 'grey darken-4'},
            ],
            [
                {hex: '#000000', name: 'black'},
                {hex: '#', name: 'white'},
                {hex: 'FFFFFF', name: ''},
            ],
        ];

        const color = ref(null);
        const menu = ref(false);

        function save(item) {
            color.value = item.name;
            emit('input', item.name);
        }

        function clear() {
            color.value = null;
            emit('input', null);
        }

        watch(() => props.value, () => {
           color.value = props.value;
        }, {immediate: true});

        return {
            colors,
            color,
            menu,
            inputColor,
            backgroundColor,
            save,
            clear,
        }
    }
}
</script>

<style scoped>

</style>